// /src/pages/Apps/TenSystematicTools.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./ten-tools.css";
import SecureSlidePlayer from "./ten-tools/components/SecureSlidePlayer"; // for Slides
import CustomFlyerModal from "../../components/org/CustomFlyerModal";
import BusinessShowerFlyerModal from "../../components/org/BusinessShowerFlyerModal";
import VideoPlayer from "../../components/VideoPlayer";

const PLAN = {
  NEW_AGENT: "New Agent",
  AGENT: "Agent",
  LEADER: "Leader",
  BROKER: "Broker",
  SENIOR_BROKER: "Senior Broker",
  ADMIN: "Admin",
};

const normalizePlan = (value) => {
  const raw = (value || "").toString().trim();
  const lower = raw.toLowerCase();
  if (!raw) return PLAN.NEW_AGENT;

  if (lower === "new agent") return PLAN.NEW_AGENT;
  if (lower === "agent") return PLAN.AGENT;
  if (lower === "leader") return PLAN.LEADER;
  if (lower === "broker") return PLAN.BROKER;
  if (lower === "senior broker") return PLAN.SENIOR_BROKER;
  if (lower === "admin") return PLAN.ADMIN;
  return raw;
};

export default function TenSystematicTools({ plan }) {
  /* ---------- Access / Roles ---------- */
  const resolvePlan = () =>
    normalizePlan(
      plan ||
        localStorage.getItem("wb.plan") ||
        localStorage.getItem("userType") ||
        PLAN.NEW_AGENT
    );

  const [userType, setUserType] = useState(resolvePlan);
  const [isAdmin, setIsAdmin] = useState(() => {
    const normalized = resolvePlan();
    return normalized === PLAN.ADMIN || localStorage.getItem("isAdmin") === "true";
  });

  useEffect(() => {
    const normalized = resolvePlan();
    setUserType(normalized);
    setIsAdmin(normalized === PLAN.ADMIN || localStorage.getItem("isAdmin") === "true");
  }, [plan]);

  /* ---------- Thumbnails (code-only) ---------- */
  // Put/replace your Firebase Storage (or any) URLs here, per item.
  const THUMBS = {
    unifiedSystemMain:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_77.png?alt=media&token=80b9c316-33e4-4790-9294-98d2f6d4199c",
    unifiedStep2:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_9.png?alt=media&token=d5a26528-86d4-4aa5-b933-936d94f10b18",
    unifiedStep3:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_10.png?alt=media&token=8604decf-e411-4e8f-b8a2-280f8587e0cc",
    unifiedStep3b:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_11.png?alt=media&token=61e3f6a6-958f-4343-a195-6922295088f5",
    unifiedBigEvent:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_12.png?alt=media&token=b3163186-39f3-4a5c-bfab-dd6f3d616651",
    unifiedStep3p1:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_13.png?alt=media&token=2ece3b2d-ecb8-43eb-b359-847dd096d69a",
    unifiedStep3p2:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_14.png?alt=media&token=11f24308-83ff-4e8d-beed-c9f9dee72c2a",
    unifiedStep4:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_15.png?alt=media&token=e88f29bc-7cc8-4830-8a56-22d73f80e43f",
    unifiedStep5:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_16.png?alt=media&token=1e9df008-c4ef-4ca0-802a-3ed515631294",

    nal: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_1.png?alt=media&token=57a8846b-b143-48eb-ade9-36ea2e1dbb10",
    nalBlueCards:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_3.png?alt=media&token=45250450-6038-4473-94fb-d8c3ace8bfcb",
    nal4fold:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_2.png?alt=media&token=c6410552-6f4c-4ce5-92bd-600f9cc05d54",

    businessShower:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_4.png?alt=media&token=05871597-a1f0-406d-beb1-893399d85b64",

    reachMarketFaq:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_5.png?alt=media&token=107ec5af-6789-430d-b15c-0caca7760e0a",

    machine:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_6.png?alt=media&token=ff5ccf0c-d4c3-40e3-b6a8-f5cb78d1c81c",
    accountability:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_7.png?alt=media&token=47b3e4b6-d990-4568-9bdb-7a4d22ddf73a",
    trainerManual:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_8.png?alt=media&token=fd9ab14d-0f9f-4c80-8167-35c5c59e59d8",
    dropByPhilosophies:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Screenshot%202026-04-19%20193745.png?alt=media&token=3a85f65a-bf3a-43d2-8693-6d1774260c4f",
  };

  /* ---------- Embed Links ---------- */
  const SLIDE_EMBEDS = {
    unifiedSystem:
      "https://docs.google.com/presentation/d/e/2PACX-1vRyNAB8mooy4OzVU_gcfs20l4cw8g5-xulXPR37LPzJaV54jzH9yuwhyiRLoaN-sE17uwW4u79aGwWn/pubembed?start=false&loop=false&delayms=3000",
    "nal:main":
      "https://docs.google.com/presentation/d/e/2PACX-1vRyNAB8mooy4OzVU_gcfs20l4cw8g5-xulXPR37LPzJaV54jzH9yuwhyiRLoaN-sE17uwW4u79aGwWn/pubembed?start=false&loop=false&delayms=3000",
    "nal:ca":
      "https://docs.google.com/presentation/d/e/2PACX-1vSH8BAmFtZD1nNRZM2DGyuUcVYalL6Za88l3kvuebW7acoMhv0J7nKkwPIVhmFhySXd2wlVCBRUerYi/pubembed?start=false&loop=false&delayms=60000",
    "bs:main":
      "https://docs.google.com/presentation/d/e/2PACX-1vSvtcwPkHKdB8JISQJmNRRd_tHnAj2pC5t86PsbaB523E9W6DG_GwT5tcCzekqKZC067I4fdpmnKzGN/pubembed?start=false&loop=false&delayms=60000&slide=id.g3716174d206_3_0",
    "bs:ca":
      "https://docs.google.com/presentation/d/e/2PACX-1vR3LDPYQQyMTee02-LVHG9nGNU1Jw92VX5wQyTIQR2og0EqYkln_NnFq9edfMibuA4WerqI4P6dLc4D/pubembed?start=false&loop=false&delayms=60000",
    "nal4:present":
      "https://docs.google.com/presentation/d/e/2PACX-1vQ5LDIv1q6M9XIZX8IyGH0keFnRKxwELd3F2Be8SXMrGs98fxs4NKDzEexZ3VwSDcDkkpj-KWKv-bc6/pubembed?start=false&loop=false&delayms=60000",
    "smd:main":
      "https://docs.google.com/presentation/d/e/2PACX-1vTnDiDvxbA6TDW42UgkZg_VAJp_j0D5QKJJcjDB59sNM-aueoo7AgNAVP4yLdETmY_6N1AWSXf-N1tZ/pubembed?start=false&loop=false&delayms=3000",
    "smd:abcs": 
      "https://docs.google.com/presentation/d/e/2PACX-1vR4krZNkSnkDIQP7gTpGaePIggFFIvqvq_TFEq49I-XiGq8zUyyon3cNSU_cODD9tM_3uTwhkQDcf5s/pubembed?start=false&loop=false&delayms=3000",
  };
  const PDF_FILES = {
    fourFold:
      "https://drive.google.com/file/d/1-GYpGxZpQm8xSdlQl8qfXLeK0bmq0-eb/preview",
    reachMarketFaq:
      "https://drive.google.com/file/d/19T5-pcGG2DMPzsxXGCCeRg1Tqteo9-lI/preview",
    machine:
      "https://drive.google.com/file/d/1WNhK2Crwt_zwE2DsBqyCZ_GDk8p_EfDI/preview",
    accountability:
      "https://drive.google.com/file/d/1_V0uXOsHttT1DGNuMAQw_TfdLYQYm6WY/preview",
    trainerManual:
      "https://drive.google.com/file/d/1oea9UDffzT3lX7NZqQMV3TWT7qvWSLY5/preview",
    businessShowerBlueCards:
      "https://drive.google.com/file/d/11HBseh37Hvjwj093LsuGnNRwM59_YnTn/preview",
    newArtBlueCards:
      "https://drive.google.com/file/d/1l6xx0z2k5vQ6Tm_-mPIcWc1-EmsoOBfN/preview",
    dropByPhilosophies:
      "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Philosophies-%20updated-%207%20march.pdf?alt=media&token=05d49767-0779-44ba-9d3a-67de820c8ce0",
  };

  /* ---------- Access map ---------- */
  const accessMap = {
    [PLAN.NEW_AGENT]: [1, 2, 3, 4, 5, 6, 7, 10],
    [PLAN.AGENT]: [1, 2, 3, 4, 5, 6, 7, 10],
    [PLAN.LEADER]: [1, 2, 3, 4, 5, 6, 7, 9, 10],
    [PLAN.BROKER]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    [PLAN.SENIOR_BROKER]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    [PLAN.ADMIN]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  };

  const allowedIndexesForPlan = (planName) =>
    new Set(accessMap[planName] || accessMap[PLAN.NEW_AGENT]);

  const cloneMenuItem = (item) => ({
    ...item,
    options: Array.isArray(item.options)
      ? item.options.map((opt) => ({ ...opt }))
      : undefined,
    singleOption: item.singleOption ? { ...item.singleOption } : undefined,
  });

  const applyPlanFilters = (item, planName) => {
    if (planName !== PLAN.NEW_AGENT) return item;

    if (item.id === "unified-system") {
      const filteredOptions = (item.options || []).filter((opt) =>
        opt.title.includes("Unified System Slides")
      );
      return { ...item, options: filteredOptions };
    }

    if (item.id === "new-art-of-living") {
      const filtered = (item.options || []).filter(
        (opt) => opt.openModal === "nalFlyer"
      );
      return { ...item, options: filtered };
    }

    if (item.id === "business-shower") {
      const filtered = (item.options || []).filter(
        (opt) => opt.openModal === "businessShowerFlyer"
      );
      return { ...item, options: filtered };
    }

    return item;
  };

  const filterMenuForPlan = (menu, planName) => {
    const allowedIndexes = allowedIndexesForPlan(planName);
    return menu
      .filter((item) => allowedIndexes.has(item.gateIndex))
      .map((item) => applyPlanFilters(cloneMenuItem(item), planName));
  };

  /* ---------- Default menu (code defines thumbnails) ---------- */
  const DEFAULT_MENU = [
    {
      gateIndex: 1,
      id: "unified-system",
      label: "Unified System Presentation",
      options: [
        {
          // title: "Unified System Slides",
          title: "Step 1 English",
          thumb: 'https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Thumbnails%2FWhatsApp%20Image%202026-02-01%20at%205.08.37%20AM.jpeg?alt=media&token=73e2c393-1b68-448a-8a2d-ad2df9ca6856',
          embedSrc: SLIDE_EMBEDS.unifiedSystem,
        },
        {
          title: "Step 2 English",
          thumb: 'https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Thumbnails%2FWhatsApp%20Image%202026-02-01%20at%205.10.41%20AM.jpeg?alt=media&token=be47716f-c374-4d75-b784-6623a0f4f01d',
          embedSrc: 'https://docs.google.com/presentation/d/e/2PACX-1vR-U8zstEic_AvvMRDEE_6bX2I4niyU75VALnf0ijKuE3Lt0CaHJMEFd3UW9-xIuurxzhBqU_j9cimo/pubembed?start=false&loop=false&delayms=3000',
        },
        {
          title: "Step 1 Spanish",
          thumb: 'https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Thumbnails%2FWhatsApp%20Image%202026-02-01%20at%205.08.37%20AM.jpeg?alt=media&token=73e2c393-1b68-448a-8a2d-ad2df9ca6856',
          embedSrc: 'https://docs.google.com/presentation/d/e/2PACX-1vRTSEyfCW54MgP3hOVKwubnnuGoxF-TjY6TnPMbcjaFxj9oIChTbI-rwVgQZyqw1xe3-F164MuKEja2/pubembed?start=false&loop=false&delayms=3000',
        },
        {
          title: "Step 2 Spanish",
          thumb: 'https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Thumbnails%2FWhatsApp%20Image%202026-02-01%20at%205.10.41%20AM.jpeg?alt=media&token=be47716f-c374-4d75-b784-6623a0f4f01d',
          embedSrc: 'https://docs.google.com/presentation/d/e/2PACX-1vTdbS4MrgdOkf2YXsiAHZUIfcFEllIiRIN9Rzmm05YH3F_gLSe4IaN3rTABbHA9aMcySujtjRaE9L7h/pubembed?start=false&loop=false&delayms=3000',
        },
        // {
        //   title: "Step 3 (Video)",
        //   thumb: THUMBS.unifiedStep3,
        //   embedSrc:
        //     "https://player.vimeo.com/video/1055385293?h=e177338da3&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
        // },
        // {
        //   title: "Step 3 II (Video)",
        //   thumb: THUMBS.unifiedStep3b,
        //   embedSrc:
        //     "https://player.vimeo.com/video/1055388014?h=41cd6a09ce&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
        // },
        // {
        //   title: "Big Event (Video)",
        //   thumb: THUMBS.unifiedBigEvent,
        //   embedSrc:
        //     "https://player.vimeo.com/video/1071962451?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
        // },
        // {
        //   title: "Step 3 Part 1 (Slides)",
        //   thumb: THUMBS.unifiedStep3p1,
        //   embedSrc:
        //     "https://docs.google.com/presentation/d/e/2PACX-1vTnDlQREx1_BBbCTKp3Xpmee4zPdJrQ0o0VIv-0qsXvPQTOFXl9PpQtL8Ya_08Wy46nA6WJnwsX8zXo/pubembed?start=false&loop=false&delayms=3000",
        // },
        // {
        //   title: "Step 3 Part 2 (Slides)",
        //   thumb: THUMBS.unifiedStep3p2,
        //   embedSrc:
        //     "https://docs.google.com/presentation/d/e/2PACX-1vSUQtXAr20Z7BufVUtacj2YLEsI03WRja-CrjtVz8NbUc8M0MQcxWebLx1P-llv2ROqJypJcP4BLZG8/pubembed?start=false&loop=false&delayms=3000",
        // },
        // {
        //   title: "Step 4 (Slides)",
        //   thumb: THUMBS.unifiedStep4,
        //   embedSrc:
        //     "https://docs.google.com/presentation/d/e/2PACX-1vSwoTfdWXzjtl7TI_F18WrnrCQ6NKsPd7UVD4Wr3RDql3S3h34P5nAtOm-lTfxAJ66RAqc2hh9o7L1u/pubembed?start=false&loop=false&delayms=3000",
        // },
        // {
        //   title: "Step 5 (Slides)",
        //   thumb: THUMBS.unifiedStep5,
        //   embedSrc:
        //     "https://docs.google.com/presentation/d/e/2PACX-1vQ43J2v747MtEBj50k5F7O5LtG6i24hk4_PUNrkvG1eqcDUcGXUAMgLD8pLHMMuqUgYV0zufFt5GjDy/pubembed?start=false&loop=false&delayms=3000",
        // },
      ],
    },
    {
      gateIndex: 2,
      id: "new-art-of-living",
      label: "New Art of Living Presentation",
      options: [
        {
          title: "Presentation",
          thumb: THUMBS.nal,
          embedSrc: SLIDE_EMBEDS["nal:main"],
        },
        { title: "Custom Flyer", thumb: THUMBS.nal, openModal: "nalFlyer" },
        {
          title: "Blue cards",
          thumb: THUMBS.nalBlueCards,
          embedSrc: PDF_FILES.newArtBlueCards,
        },
        {
          title: "Presentation (Canada)",
          thumb: THUMBS.nal,
          embedSrc: SLIDE_EMBEDS["nal:ca"],
        },
      ],
    },
    {
      gateIndex: 3,
      id: "new-art-of-living-4fold",
      label: "New Art of Living 4 Fold",
      options: [
        {
          title: "Printable 4 fold (PDF)",
          thumb: THUMBS.nal4fold,
          embedSrc: PDF_FILES.fourFold,
        },
        {
          title: "4 Fold Presentation (Slides)",
          thumb: THUMBS.nal4fold,
          embedSrc: SLIDE_EMBEDS["nal4:present"],
        },
        {
          title: "New Art of Living video",
          thumb: THUMBS.nal4fold,
          onClick: () => alert("Link not set yet."),
        },
      ],
    },
    {
      gateIndex: 4,
      id: "business-shower",
      label: "Business Shower",
      options: [
        {
          title: "Presentation",
          thumb: THUMBS.businessShower,
          embedSrc: SLIDE_EMBEDS["bs:main"],
        },
        {
          title: "Custom Flyer",
          thumb: THUMBS.businessShower,
          openModal: "businessShowerFlyer",
        },
        {
          title: "Blue cards",
          thumb: THUMBS.nalBlueCards,
          embedSrc: PDF_FILES.businessShowerBlueCards,
        },
        {
          title: "Presentation (Canada)",
          thumb: THUMBS.businessShower,
          embedSrc: SLIDE_EMBEDS["bs:ca"],
        },
      ],
    },
    {
      gateIndex: 5,
      id: "reach-market-faq",
      label: "3 Ways to reach the Market & FAQ",
      options: [
        {
          title: "Open PDF",
          thumb: THUMBS.reachMarketFaq,
          embedSrc: PDF_FILES.reachMarketFaq,
        },
      ],
    },
    {
      gateIndex: 6,
      id: "unified-licensing",
      label: "Unified Licensing & Distribution System",
    },
    {
      gateIndex: 7,
      id: "distribution-machine",
      label: "Distribution Machine & Acc Sheet",
      options: [
        {
          title: "Machine (PDF)",
          thumb: THUMBS.machine,
          embedSrc: PDF_FILES.machine,
        },
        {
          title: "Accountability (PDF)",
          thumb: THUMBS.accountability,
          embedSrc: PDF_FILES.accountability,
        },
      ],
    },
    {
      gateIndex: 8,
      id: "smd-100k-class",
      label: "Classes",
      options: [
        {
        title: "SMD & 100k Class Presentation",
        thumb: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/NAL%20Thumbnails%2FScreenshot_77.png?alt=media&token=80b9c316-33e4-4790-9294-98d2f6d4199c",
        embedSrc: SLIDE_EMBEDS["smd:main"],
      },
      {
        title: "2026 ABCs of Finance",
        thumb: "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/thumbnails%2FScreenshot%202026-04-09%20212530.png?alt=media&token=000c98b7-f88f-4a94-aec3-74dc6f963b06",
        embedSrc: SLIDE_EMBEDS["smd:abcs"],
      },
      ],
    },
    {
      gateIndex: 9,
      id: "trainer-manual",
      label: "Trainer Manual",
      singleOption: {
        title: "Open Trainer Manual (PDF)",
        thumb: THUMBS.trainerManual,
        embedSrc: PDF_FILES.trainerManual,
      },
    },
    {
      gateIndex: 10,
      id: "drop-by",
      label: "Drop By",
      singleOption: {
        title: "Philosophies (PDF)",
        embedSrc: PDF_FILES.dropByPhilosophies,
        thumb: THUMBS.dropByPhilosophies,
      },
    },
    { gateIndex: 11, id: "boot-camp", label: "Boot Camp" },
  ];

  /* ---------- Persist menu to localStorage ---------- */
  const MENU_KEY = "tenTools:menu";
  const loadMenuFromStorage = () => {
    try {
      const raw = localStorage.getItem(MENU_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };
  const saveMenuToStorage = (menu) => {
    try {
      localStorage.setItem(MENU_KEY, JSON.stringify(menu));
    } catch {}
  };

  const initialMenuRef = useRef(loadMenuFromStorage() || DEFAULT_MENU);

  const [menuData, setMenuData] = useState(() => initialMenuRef.current);

  /* ---------- Active page ---------- */
  const [activeId, setActiveId] = useState(
    () => initialMenuRef.current?.[0]?.id || null
  );
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100;

  const visibleMenu = useMemo(
    () => filterMenuForPlan(menuData, userType),
    [menuData, userType]
  );
  
  useEffect(() => {
    if (!visibleMenu.find((m) => m.id === activeId)) {
      setActiveId(visibleMenu[0]?.id || null);
    }
  }, [visibleMenu, activeId]);
  
  const activeItem = useMemo(
    () => visibleMenu.find((m) => m.id === activeId) || visibleMenu[0],
    [visibleMenu, activeId]
  );

  // Reset pagination when switching active items
  useEffect(() => {
    setCurrentPage(1);
  }, [activeId]);

  /* ---------- Player overlay ---------- */
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const [playerSrc, setPlayerSrc] = useState("");
  const [playerTitle, setPlayerTitle] = useState("");
  const [showFlyerModal, setShowFlyerModal] = useState(false);
  const [showBusinessShowerModal, setShowBusinessShowerModal] = useState(false);
  const isSlidesUrl = (src) =>
    typeof src === "string" && (src.includes("/pubembed?") || src.includes("/embed?"));
  const isPdfUrl = (src) =>
    typeof src === "string" &&
    (src.includes("/preview") ||
      src.includes("drive.google.com") ||
      src.toLowerCase().includes(".pdf"));
   const openEmbed = (src, title) => {
    setPlayerSrc(src);
    setPlayerTitle(title || "Viewer");
    setIsPlayerOpen(true);
  };

  /* ---------- View actions ---------- */
  const onOptionActivate = (opt, labelPrefix = "") => {
    if (opt.openModal === "nalFlyer") {
      setShowFlyerModal(true);
      return;
    }
    if (opt.openModal === "businessShowerFlyer") {
      setShowBusinessShowerModal(true);
      return;
    }
    if (opt.route) {
      window.location.href = opt.route;
      return;
    }
    if (opt.embedSrc) {
      if (isSlidesUrl(opt.embedSrc)) {
        setPlayerTitle(`${labelPrefix}${opt.title}`);
        setPlayerSrc(opt.embedSrc);
        setIsPlayerOpen(true);
      } else {
        openEmbed(opt.embedSrc, `${labelPrefix}${opt.title}`);
      }
      return;
    }
    if (opt.onClick) opt.onClick();
  };

  const onLeftKeyDown = (e) => {
    if (!visibleMenu.length) return;

    const idx = visibleMenu.findIndex((m) => m.id === activeId);
    const safeIndex = idx === -1 ? 0 : idx;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const next = visibleMenu[(safeIndex + 1) % visibleMenu.length];
      if (next) setActiveId(next.id);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const next = visibleMenu[(safeIndex - 1 + visibleMenu.length) % visibleMenu.length];
      if (next) setActiveId(next.id);
    }
  };

  /* ---------- EDIT MODE (admins only) ---------- */
  const [editMode, setEditMode] = useState(false);
  const [draftItems, setDraftItems] = useState([]);
  useEffect(() => {
    if (!editMode || !activeItem) return;
    const src = activeItem;
    let items = [];
    if (src.singleOption) items = [src.singleOption];
    if (Array.isArray(src.options)) items = src.options.slice();
    // no thumbnail editing — titles/embeds/route only
    setDraftItems(
      items.map((it) => ({
        title: it.title || "",
        embedSrc: it.embedSrc || "",
        route: it.route || "",
      }))
    );
  }, [editMode, activeItem]);

  const addDraftItem = () => {
    setDraftItems((arr) => [
      ...arr,
      { title: "New item", embedSrc: "", route: "" }, // no thumb here
    ]);
  };
  const updateDraftItem = (i, patch) => {
    setDraftItems((arr) =>
      arr.map((it, idx) => (idx === i ? { ...it, ...patch } : it))
    );
  };
  const deleteDraftItem = (i) => {
    setDraftItems((arr) => arr.filter((_, idx) => idx !== i));
  };
  const moveDraftItem = (i, dir) => {
    setDraftItems((arr) => {
      const to = dir === "up" ? i - 1 : i + 1;
      if (to < 0 || to >= arr.length) return arr;
      const copy = arr.slice();
      const [item] = copy.splice(i, 1);
      copy.splice(to, 0, item);
      return copy;
    });
  };

  const saveDraft = () => {
    const newMenu = menuData.map((m) => {
      if (m.id !== activeItem.id) return m;

      // merge back keeping the original thumbs from code
      const original = m.singleOption
        ? [m.singleOption]
        : Array.isArray(m.options)
        ? m.options
        : [];
      const cleaned = draftItems
        .map((d, idx) => {
          const src = original[idx] || {};
          return {
            // keep existing thumb if it existed in that position
            thumb: src.thumb,
            title: (d.title || "").trim(),
            embedSrc: (d.embedSrc || "").trim(),
            route: (d.route || "").trim(),
          };
        })
        .filter((d) => d.title);

      if (cleaned.length <= 1) {
        const single = cleaned[0] || undefined;
        return { ...m, singleOption: single, options: undefined };
      }
      return { ...m, singleOption: undefined, options: cleaned };
    });

    setMenuData(newMenu);
    saveMenuToStorage(newMenu);
    setEditMode(false);
  };

  const cancelDraft = () => setEditMode(false);

  /* ---------- Render helpers ---------- */
  const renderCard = (opt, onClick) => (
    <button
      className="vault-card as-button"
      onClick={onClick}
      title={opt.title}
    >
      {opt.thumb ? (
        <div className="thumb-wrap">
          <img src={opt.thumb} alt={opt.title} loading="lazy" />
        </div>
      ) : (
        <div className="thumb-wrap" />
      )}
      <div className="card-foot">
        <span className="name">{opt.title}</span>
      </div>
    </button>
  );

  const renderRow = (opt, onClick) => (
    <button className="vault-row as-button" onClick={onClick} title={opt.title}>
      <span className="row-title">{opt.title}</span>
      <span className="row-arrow">›</span>
    </button>
  );

  // Pagination helpers
  const getCurrentItems = () => {
    if (!activeItem) return [];
    if (activeItem.singleOption) {
      return [activeItem.singleOption];
    }
    if (Array.isArray(activeItem.options) && activeItem.options.length) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      return activeItem.options.slice(startIndex, endIndex);
    }
    return [];
  };

  const getTotalPages = () => {
    if (!activeItem) return 0;
    if (activeItem.singleOption) return 1;
    if (Array.isArray(activeItem.options)) {
      return Math.ceil(activeItem.options.length / itemsPerPage);
    }
    return 0;
  };

  const renderPagination = () => {
    const totalPages = getTotalPages();
    if (totalPages <= 1) return null;

    return (
      <div className="pagination-controls">
        <button
          className="pagination-btn"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
        >
          ←
        </button>
        
        <div className="pagination-info">
          Page {currentPage} of {totalPages}
        </div>
        
        <button
          className="pagination-btn"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(prev => prev + 1)}
        >
          →
        </button>
      </div>
    );
  };

  const renderRightView = () => {
    if (!activeItem) {
      return (
        <div className="content-stage">
          <div className="stage-text">
            <p>No tools are available for your current plan yet.</p>
          </div>
        </div>
      );
    }

    if (!editMode) {
      const currentItems = getCurrentItems();
      
      if (currentItems.length === 0) {
        return (
          <section className="vault-grid">
            <div className="empty">No content available yet for this item.</div>
          </section>
        );
      }

      return (
        <div className="vault-content">
          <section className="vault-grid" style={{ gridTemplateColumns: `${activeItem.id === 'unified-system' ? '300px 300px' : 'repeat(auto-fill, minmax(260px, 1fr))'}` }}>
            {currentItems.map((opt, i) =>
              opt.thumb
                ? renderCard(opt, () => onOptionActivate(opt, ""))
                : renderRow(opt, () => onOptionActivate(opt, ""))
            )}
          </section>
          {renderPagination()}
        </div>
      );
    }

    // EDIT MODE (no thumbnail fields)
    return (
      <section className="edit-panel">
        <div className="editor-note">
          Edit the items for <strong>{activeItem.label}</strong>. Paste
          Vimeo/Slides/PDF embed links in <code>Embed URL</code>, or use{" "}
          <code>Route</code> for internal pages.
          <br />
          <em>
            Thumbnails are code-only. To change a thumbnail, edit the{" "}
            <code>DEFAULT_MENU</code> item in this file.
          </em>
        </div>

        <div className="edit-list">
          {draftItems.map((it, i) => (
            <div className="edit-item" key={`draft-${i}`}>
              <div className="edit-row">
                <label>Title</label>
                <input
                  value={it.title || ""}
                  onChange={(e) =>
                    updateDraftItem(i, { title: e.target.value })
                  }
                  placeholder="Item title"
                />
              </div>
              <div className="edit-row two">
                <div>
                  <label>Embed URL (Slides, Vimeo, PDF)</label>
                  <input
                    value={it.embedSrc || ""}
                    onChange={(e) =>
                      updateDraftItem(i, { embedSrc: e.target.value })
                    }
                    placeholder="https://... (leave blank if using Route)"
                  />
                </div>
                <div>
                  <label>Route (internal)</label>
                  <input
                    value={it.route || ""}
                    onChange={(e) =>
                      updateDraftItem(i, { route: e.target.value })
                    }
                    placeholder="/some-internal-path"
                  />
                </div>
              </div>

              <div className="edit-actions">
                <button
                  className="ghost"
                  onClick={() => moveDraftItem(i, "up")}
                  disabled={i === 0}
                >
                  ↑ Move up
                </button>
                <button
                  className="ghost"
                  onClick={() => moveDraftItem(i, "down")}
                  disabled={i === draftItems.length - 1}
                >
                  ↓ Move down
                </button>
                <button className="danger" onClick={() => deleteDraftItem(i)}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="editor-footer">
          <button className="glass-btn" onClick={addDraftItem}>
            + Add item
          </button>
          <div className="spacer" />
          <button className="ghost" onClick={cancelDraft}>
            Cancel
          </button>
          <button className="glass-btn primary" onClick={saveDraft}>
            Save changes
          </button>
        </div>
      </section>
    );
  };

  return (
    <div className="vault">
      {/* LEFT: main buttons list */}
      <aside className="vault-left" onKeyDown={onLeftKeyDown} tabIndex={0}>
        <div className="vault-left-head">
          <h2>10 Systematic Tools</h2>
        </div>

        <nav className="vault-menu">
          {visibleMenu.length === 0 ? (
            <div className="empty">No tools available for this plan.</div>
          ) : (
            visibleMenu.map((m) => {
              const active = m.id === activeId;
              return (
                <button
                  key={m.id}
                  className={`vault-menu-item ${active ? "active" : ""}`}
                  onClick={() => setActiveId(m.id)}
                  title={m.label}
                >
                  <span className="icon" style={numberBadgeStyle}>
                    {m.gateIndex}
                  </span>
                  <span className="text">{m.label}</span>
                  <span className="chev">›</span>
                </button>
              );
            })
          )}
        </nav>
      </aside>

      {/* RIGHT: content for selected page */}
      <main className="vault-right">
        <header className="vault-right-head">
          <div className="title">
            <h3>{activeItem?.label || "10 Systematic Tools"}</h3>
          </div>
          {isAdmin && (
            <div className="editor-bar">
              <button
                className="glass-btn"
                onClick={() => setEditMode((v) => !v)}
              >
                {editMode ? "Close Editor" : "✎ Edit"}
              </button>
            </div>
          )}
        </header>

        {renderRightView()}
      </main>

      {/* Overlay viewer */}
      {isPlayerOpen && (
        <div className="player-overlay" onClick={() => setIsPlayerOpen(false)}>
          <div
            className="player-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="player-close-btn"
              onClick={() => setIsPlayerOpen(false)}
            >
              ✖ Close
            </button>
            <div className="player-title">{playerTitle}</div>
            {isSlidesUrl(playerSrc) ? (
              <SecureSlidePlayer embedSrc={playerSrc} />
            ) : isPdfUrl(playerSrc) ? (
              <div style={{ position: "relative", width: "100%", height: "100%" }}>
                <iframe
                  src={playerSrc}
                  title={playerTitle}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                  allowFullScreen
                />
                {/* Block pop-out button - only for trainer manual */}
                {(playerSrc.includes("1oea9UDffzT3lX7NZqQMV3TWT7qvWSLY5") || playerSrc.includes("pcGG2DMPzsxXGCCeRg1Tqteo9")) && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: 80,
                      height: 60,
                      zIndex: 10,
                      pointerEvents: "auto",
                      background: "rgba(0, 0, 0, 0.85)",
                    }}
                  />
                )}
                {
                  playerSrc.includes("Philosophies-%20updated-%207%20march.pdf") && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: 60,
                      zIndex: 10,
                      pointerEvents: "auto",
                      background: "rgba(0, 0, 0, 0.85)",
                    }}
                  />
                )}
              </div>
            ) : (
              <VideoPlayer
                title={playerTitle || "Embedded content"}
                src={playerSrc}
                className="vault-embedded-video"
                allowFullScreen
                controls
              />
            )}
          </div>
        </div>
      )}

      {/* NAL Custom Flyer Modal */}
      <CustomFlyerModal 
        isOpen={showFlyerModal}
        onClose={() => setShowFlyerModal(false)}
      />

      {/* Business Shower Flyer Modal */}
      <BusinessShowerFlyerModal 
        isOpen={showBusinessShowerModal}
        onClose={() => setShowBusinessShowerModal(false)}
      />
    </div>
  );
}

/* number badge in the left menu */
const numberBadgeStyle = {
  display: "inline-grid",
  placeItems: "center",
  width: 22,
  height: 22,
  borderRadius: 6,
  background: "rgba(255,255,255,0.06)",
  fontWeight: 700,
  fontSize: "0.8rem",
};
